<template>
  <v-layout row wrap  page v-if="this.$store.state.camdetail.id">
	   <v-flex class="al-bottom">
      	 <v-card color="white-grey darken-2" class="grey--text" v-if="cflightByPending > 0 ">
      	 	 <v-toolbar  dark class="card-header ">
      	 	 	 <h5 class="m-b-0 text-white">
                    Flight Pending 
                </h5>
      	 	 </v-toolbar>
      	 	
      	 	 	<v-expansion-panel v-model="panelIndexPending">
              <v-expansion-panel-content hide-actions v-for="(itm, idx) in flightsByPending" :key="idx">
                 <div slot="header" class="headercus">
                  
                   <h5 class="card-text font-blue-l cusfont16px no-wrap-list-s">
                    <i class="mdi mdi-alert-box text-dark"  v-if="itm.request_type=='pending_flight'"></i>
                   <!--  <div class="no-wrap-list"> <i class="mdi mdi-alert-box text-warning"></i>  -->
                         ({{itm.id}}) 
                         <a href="javascript:void(0);" class="flight_expand font-blue-l " data-toggle="collapsed" data-target="#0">  {{ itm.name }}
                         </a>
                   </h5>
                   <v-btn disabled  color="white" class="btn report-btn_d btn btn-secondary pull-right btn-report-al-right"><v-icon dark>bar_chart</v-icon>  Report
                    </v-btn>
                 
                </div>
               
                <v-card-text>
                   <div>
                    <dl>
                        <dd> {{filteredFlightType(itm)}}</dd>
                        <dt class="al-top"><span class="sl-date font-blue">
                             <span  v-for="(subdate,idex) in itm.long_flight_day" v-if="idex > 1">
                               {{subdate}}
                             </span>
                             <span  v-else>
                                {{subdate}}
                             </span>
                            {{itm.total_flight_day}}                               
                           </span>
                        </dt>
                        <dd>Inventory</dd>
                        <dt>{{itm.inventoryValue}} </dt>
                        <dd v-if="itm.flight_type !='premium' "> Base Media Cost</dd>
                        <dt v-if="itm.flight_type !='premium' "> {{filteredCurrency(currency)}}  {{ itm.base_media_cost | format_number }} 
                         </dt>
                        <dd v-if="itm.flight_type !='premium' ">Media Cost</dd>
                        <dt  v-if="itm.flight_type !='premium' ">{{filteredCurrency(currency)}}  {{ itm.media_cost | format_number }}</dt>
                        <dd>Discount</dd>
                        <dt>{{itm.discount | numofpercent}}%</dt>
                        <dd>Sales After Discount</dd>
                        <dt>{{filteredCurrency(currency)}} {{itm.cost_after_discount | format_number}}</dt>
                        <dd>Total Sales After Discount</dd>
                        <dt>{{filteredCurrency(currency)}} {{ itm.total_cost_after_discount | format_number }} </dt>
                        <dd>Agency Commission</dd>
                        <dt> {{itm.agency_commission | numofpercent}}%</dt>
                        <dd>Sales After Agency Comm</dd>
                        <dt>{{filteredCurrency(currency)}} {{ itm.cost_after_agency_commission | format_number }} </dt>
                        <dd>Sales Commission</dd>
                        <dt>{{itm.innity_commission |numofpercent}}%</dt>
                        <dd>Publisher Cost</dd>
                        <dt> {{filteredCurrency(currency)}}  {{ itm.cost_after_commission | format_number}}</dt>
                          <!--media cost-->
                        <div v-if="itm.rich_media_casual_cost > 0">
                          <dd>Rich Media Casual Cost</dd>
                          <dt>{{filteredCurrency(currency)}}  {{ itm.rich_media_casual_cost | format_number }}  </dt>
                          <dd>Rich Media Discount</dd>
                          <dt> {{itm.rich_media_discount |numofpercent}}%  </dt>
                          <dd>RM Sales After Discount</dd>
                          <dt>{{filteredCurrency(currency)}}  {{ itm.rich_media_cost_after_discount | format_number }}</dt>
                          <dd>RM Total Sales After Discount </dd>
                          <dt>{{filteredCurrency(currency)}}  {{ itm.rich_media_total_cost_after_discount | format_number }}</dt>
                          <dd>RM Rich Media Agency Comm </dd>
                          <dt> {{itm.rich_media_agency_commission |numofpercent}}%  </dt>
                          <dd>RM Sales After Agency Comm  </dd>
                          <dt>{{filteredCurrency(currency)}}  {{ itm.rich_media_cost_after_agency_commission | format_number }} </dt>
                          <dd>Rich Media Commission </dd>
                          <dt> {{itm.rich_media_commission | numofpercent}}%  </dt>
                          <dd>RM Publisher Cost </dd>
                          <dt>{{filteredCurrency(currency)}}  {{ itm.rich_media_cost_after_commission | format_number }}   </dt>

                        </div>  
                       </dl>

                    </div>                   
                  </div>
                  <div class="ribbon-wrapper card m-t-10" v-if="itm.request_type=='pending_flight'">
                      <div class="ribbon ribbon-default">New Flight</div>
                     <p class="">
                          {{itm.request_user_name}}  <span class="sl-date text-primary">{{itm.created_on}} </span>
                      </p>
                    
                      <p>

                      <custom-dialog v-model="flight_costing" 
                       :commentId="{flightid:itm.amendment_request_id}"
                        requestType="pending_flight"
                        modalTitle="Approve" ref="form1" 
                        v-if="isSalePrivilege==true"
                        />
                      <reject-dialog v-model="delete_costing" 
                        :commentId="{flightid:itm.amendment_request_id}"
                        requestType="pending_flight"
                        modalTitle="Reject" ref="form1"
                        v-if="isSalePrivilege==true"
                       />

                      </p>
                  </div>
                </v-card-text>
              </v-expansion-panel-content>
          </v-expansion-panel>
    	 </v-card>
      </v-flex>
   
    <v-flex  style="width:100%">
      	<!-- Flight-->

        <v-card color="white-grey darken-2" class="grey--text"  >
           <v-toolbar  dark class="card-header ">
             <h5 class="m-b-0 text-white">
                    Flight
              </h5>
           </v-toolbar>
            <v-card-text v-if="active">  
              <v-progress-linear
                indeterminate
                color="blue"
                class="mb-0"
                :active="active"

                ></v-progress-linear>
            </v-card-text>
          
                   
         
            <v-expansion-panel v-model="panelIndex" v-if="!active">
              <v-expansion-panel-content hide-actions  v-for="(item1, index1) in flightsByCam" :key="index1" >
                <div slot="header" class="headercus">
                <!--   <div class="pull-left "> -->
                     <h5 class="card-text font-blue-l cusfont16px no-wrap-list-s"><i class="mdi mdi-alert-box text-warning" v-if="item1.request_type=='flight_costing'"></i>
                      <i class="mdi mdi-alert-box text-danger" v-if="item1.request_type=='delete_flight'"></i>
                   <!--  <div class="no-wrap-list"> <i class="mdi mdi-alert-box text-warning"></i>  -->
                      <span class="badge badge-success"v-if="item1.master_sub == 'sub'">Sub</span>
                     <!--   <span class='alert alert-success' v-if="item1.master_sub == 'sub'">Sub</span> -->
                         ({{item1.id}}) 
                         <a href="javascript:void(0);" class="flight_expand font-blue-l line-h" data-toggle="collapsed" data-target="#0">  {{ item1.name }}
                         </a>
              
                   </h5>
                   <v-btn color="white" class="btn report-btn_d btn btn-secondary pull-right btn-report-al-right" @click="$router.push({name: 'report', params: { id: item1.id },})"><v-icon dark>bar_chart</v-icon>  Report
                    </v-btn>
               
                </div>

              
                <v-card-text>
                
                  <div>
                    <dl>

                       <dd class="al-top1" v-if="item1.deal">
                          <span>Deal ID </span>
                          <br>
                          <span class="font-bold">{{item1.deal.deal_id}} ({{item1.deal.dsp_seat}} - {{item1.deal.buyer_id}} )</span>
                        
                      
                       </dd>
                        <dd> {{filteredFlightType(item1)}}</dd>
                        <dt class="al-top"><span class="sl-date font-blue">
                             <span  v-for="(subdate,idex) in item1.long_flight_day" v-if="idex > 1">
                               {{subdate}}
                             </span>
                             <span  v-else>
                                {{subdate}}
                             </span>
                            {{item1.total_flight_day}}                               
                           </span>
                        </dt>
                        <dd>Inventory</dd>
                        <dt>{{item1.inventoryValue}} </dt>
                        <dd v-if="item1.flight_type !='premium' "> Base Media Cost</dd>
                        <dt v-if="item1.flight_type !='premium' ">{{filteredCurrency(currency)}} {{ item1.base_media_cost | format_number }}
                        </dt>
                        
                        <dd v-if="item1.flight_type !='premium' ">Media Cost</dd>
                        <dt  v-if="item1.flight_type !='premium' ">{{filteredCurrency(currency)}}  {{ item1.media_cost | format_number}}</dt>
                        <dd>Discount</dd>
                        <dt>{{item1.discount | numofpercent}}%</dt>
                        <dd>Sales After Discount</dd>
                        <dt>{{filteredCurrency(currency)}} {{item1.cost_after_discount | format_number}}</dt>
                        <dd>Total Sales After Discount</dd> 
                        <dt>{{filteredCurrency(currency)}} {{ item1.total_cost_after_discount | format_number  }} </dt>
                        
                        <dd  v-if="!item1.deal">Agency Commission</dd>
                        <dt  v-if="!item1.deal"> {{item1.agency_commission | numofpercent}}%</dt>
                        
                        
                        <dd v-if="item1.deal">Tech fee</dd>
                        <dt v-if="item1.deal">{{item1.tech_fee | numofpercent}}%</dt> 
                        
                        <dd>Sales After Agency Comm</dd>
                        <dt>{{filteredCurrency(currency)}} {{ item1.cost_after_agency_commission | format_number }} </dt>
                        <dd>Sales Commission</dd>
                        <dt>{{item1.innity_commission |numofpercent}}%</dt>
                        <dd>Publisher Cost</dd>
                        <dt>{{filteredCurrency(currency)}}   {{ item1.cost_after_commission |format_number}}</dt>
                          <!--media cost-->
                        <div v-if="item1.rich_media_casual_cost > 0">
                          <dd>Rich Media Casual Cost</dd>
                          <dt>{{filteredCurrency(currency)}} {{ item1.rich_media_casual_cost | format_number }}  </dt>
                          <dd>Rich Media Discount</dd>
                          <dt> {{item1.rich_media_discount |numofpercent}}%  </dt>
                          <dd>RM Sales After Discount</dd>
                          <dt>{{filteredCurrency(currency)}}  {{ item1.rich_media_cost_after_discount | format_number }}</dt>
                          <dd>RM Total Sales After Discount </dd>
                          <dt>{{filteredCurrency(currency)}}  {{ item1.rich_media_total_cost_after_discount | format_number }}</dt>
                          <dd>RM Rich Media Agency Comm </dd>
                          <dt> {{item1.rich_media_agency_commission |numofpercent}}%  </dt>
                          <dd>RM Sales After Agency Comm  </dd>
                          <dt>{{filteredCurrency(currency)}}  {{ item1.rich_media_cost_after_agency_commission | format_number }} </dt>
                          <dd>Rich Media Commission </dd>
                          <dt> {{item1.rich_media_commission | numofpercent}}%  </dt>
                          <dd>RM Publisher Cost </dd>
                          <dt>{{filteredCurrency(currency)}} {{ item1.rich_media_cost_after_commission | format_number }}   </dt>

                        </div>  
                    </dl>

                    </div>                   
                  </div>

                  <div class="ribbon-wrapper card m-t-10" v-if="check_box(item1.request_type) == true">
                      <div class="ribbon " v-bind:class="request_class(item1.request_type)">{{show_title(item1.request_type)}}</div>
                      <p class="">
                          {{item1.request_user_name}}  <span class="sl-date text-primary">{{item1.created_on}} </span>
                      </p>
                      

                     <!--  <p class=""><span class="">Reason </span></p> -->
                      <p class="ribbon ribbon_cus ribbon-danger" v-if="item1.has_delete_request">Delete Request</p>
                      <p class=""><span class="font-bold">{{item1.reason}}</span></p>

                      <p class="text-muted" v-if="item1.request_type=='flight_costing'">
                            <table class="itemdata table table-hover" v-for="(itm,index) in item1.item_update " >
                              <tbody>
                                <tr class="bordertable">
                                   <td> <span class="text-muted">Item </span></td>
                                  <td class="text-right text-muted">{{index}}</td>
                                </tr>
                                <tr>
                                   <td>Old Value</td>
                                   <td class="text-right">{{itm.old}}</td>
                                </tr>
                                <tr>
                                   <td>New Value</td>
                                   <td class="text-right"><div v-html="handleNewLine(itm.new)"></div></td>
                                </tr>
                              </tbody>
                            </table>
                        
                      </p>
                      <p v-if="item1.request_type=='flight_costing'">

                      <custom-dialog v-model="flight_costing" 
                        :commentId="{flightid:item1.amendment_request_id}"

                        requestType="flight_costing"
                        modalTitle="Approve" ref="form1" 
                        v-if="isSalePrivilege==true"
                        />
                      <reject-dialog v-model="delete_costing" 
                        :commentId="{flightid:item1.amendment_request_id}"
                        requestType="flight_costing"
                        modalTitle="Reject" ref="form1"
                        v-if="isSalePrivilege==true"
                       />

                      </p>
                      <p v-if="item1.request_type=='delete_flight'">
                        <custom-dialog v-model="flight_costing" 
                        :commentId="{flightid:item1.amendment_request_id}"

                        requestType="delete_flight"
                        modalTitle="Approve" ref="form1" 
                        v-if="isSalePrivilege==true"
                        />
                      <reject-dialog v-model="delete_costing" 
                        :commentId="{flightid:item1.amendment_request_id}"
                        requestType="delete_flight"
                        modalTitle="Reject" ref="form1"
                        v-if="isSalePrivilege==true"
                       />

                      </p>
                  </div>
                  <div v-else-if="item1.has_delete_request" class="ribbon-wrapper card m-t-10">
                      <p class="ribbon ribbon-danger">Delete Request</p>
                  </div>
                </v-card-text>
           
           
            </v-expansion-panel-content>
            </v-expansion-panel>
            <v-card-text class="notfound" v-else-if="cFlightByCam==0 && !active" >No Data Found</v-card-text>
          
        </v-card >
       
    </v-flex>
    

  </v-layout>
</template>
<style scoped>
  .al-top1{
     margin-top: 12px;
  }
  .ribbon_cus{
        padding: 0 10px !important; 
  }
  .v-card__text{
          padding: 8px !important;
  }
  dt{
    font-weight: bold;
  }
  .cus{
    border: 1px red solid !important;
    position: relative;
    left: -101px;
  }
  .report-btn_d{
    min-width: 58px !important;
    width: 81px;
  }
  .pull_right_r{
      width: 87px;
      display: inline-flex;
      /*padding-left: 35px;*/
  }
  .report-btn_d{
    z-index: 170;
  }
  .theme--light.v-card{
    /*width: 374px;*/
  }
  

</style>
<script>
  import CustomDialog from '@/components/CustomDialog';
  import RejectDialog from '@/components/RejectDialog';
  import { loginService } from '@/components/_service/Users.js'
  import { StatusColor,CurrencyCode } from '@/components/_service/Config.js'
  export default {
    name: 'FlightList',
    components: {
      CustomDialog,
      RejectDialog,
      
    },
    data () {
        return {
          id:"",
          flightsByPending:[],
          countFlightByPending:0,
          flightsByCam:[],
          countFlightByCam:0,
         // currency:"",
          //flight_type:"Ad Network",
          datestring:"",
          modalTitle:"",
          status:"",
          isModalVisible:false,
          panelIndex:[],
          panelIndexPending:[],
          flightid:0 ,
          act:"",
          flight_costing: true,
          delete_costing: true,         
          cssClosed : "fa-plus",
          dialog: false,
          rst_class:"ribbon-warning",
          active:true,
        }
    },
    watch: {
      
    },
       computed: {
        cflightByPending () {
        
          return Object.keys(this.flightsByPending).length;
          
        },
        cFlightByCam () {
            //console.log(Object.keys(this.flightsByCam).length)
          return Object.keys(this.flightsByCam).length;
         
        },
        currency(){
          return this.$store.state.currency
        },
        isSalePrivilege(){
        //  console.log( this.$store.state.isSalePrivilege.approve_flight_request)
          return this.$store.state.isSalePrivilege.approve_flight_request
        }
      },
      methods:{
          check_box(request_type){
              if (request_type=='flight_costing' || request_type=='delete_flight'){
                return true;
              }
              return false;
          },
          show_title(request_type){
             
              if (request_type=='flight_costing'){
                return "New Request";
              }else if(request_type =='delete_flight'){
                return "Delete Request";
              }
          },
          request_class(request_type){
        
              if (request_type =="flight_costing"){
                  return this.rst_class = "ribbon-warning";
              }else if(request_type =="delete_flight"){
                  return this.rst_class = "ribbon-danger";
              }else{
                  return this.rst_class = "ribbon-warning";
              }
          },
          getsalePrivilege(){
              this.$store.dispatch('checkCampaignAccess')
               .then(() => 
                  this.loading =false
               
                )
               .catch(err => {
                  console.log(err )
                 
               })
              
        
          },
       getFlightByPending(){

          if (this.id !==""){
            loginService.flightbyPending(this.id).then((data)=>{
                 this.flightsByPending =  data;
                 this.pending_flight_data(data);
               });
          //  console.log(this.data );
          }
        },
        getFlightByCam(){
          if (this.id !==""){
            loginService.flightbyCam(this.id).then((data)=>{
                this.flightsByCam =  data;
                this.flight_costing_data(data);
               });
         
          }
        }, 
        pending_flight_data(data){
          var i = 0;
          for ( var x in data) {
              if (this.flightid == data[x].id){
                  this.panelIndexPending = i;
                  break;
              }
             
             i ++;
          }
        },
        flight_costing_data(data){
          var i = 0;
          for ( var x in data) {
              if (this.flightid == data[x].id){
                  this.panelIndex = i;
                  break;
              }
             
             i ++;
          }
        },
        filteredCurrency(currency){
            var currency_ = "MYR";
            Object.keys(CurrencyCode).forEach(key => {
              const item =  CurrencyCode[key]
             //console.log (item)
             
              if (currency == key){
                //console.log(key)
                  currency =  item
              }
            })  
            return currency;
        },
        filteredFlightType(item1){
            var  flight_type = "Ad Network"
           if (item1.platform && item1.flight_type=="premium"){
               flight_type="Premium"
           }
           return flight_type;
        },
        doSomething (e,n) {         
         if (e.currentTarget.getAttribute('id') == n){

              if (e.currentTarget.firstChild.childNodes[0].parentElement.className === "v-expansion-panel__container v-expansion-panel__container--active"){
              //  console.log(e.currentTarget.firstChild.childNodes[0].childNodes[0].childNodes[0])
                  const arr = e.currentTarget.firstChild.childNodes[0].childNodes[0].childNodes[0].childNodes[0].classList
                  //arr.value ="fa-minus"
                //  if ( arr.value == "")
                 this.openSection = false;
               
                 arr.value ="fa fa-fw fa-plus"
             //     console.log( arr.value )  
               
                 
               }else{
                 const arr = e.currentTarget.firstChild.childNodes[0].childNodes[0].childNodes[0].childNodes[0].classList
                  arr.value ="fa fa-fw fa-minus"
                this.openSection = true;
               
             }
           
         }
       
      },
     handleNewLine(str) {
         //var daaa ="4 Dec, 2018 - 31 Dec, 2018 &lt;br /&gt; 1 Feb, 2020 - 14 Feb, 2020";
        // console.log( str.replace(/(?:\r\n|\r|\n)/g, '<br />'))
           return str.replace(/(?:\r\n|\r|\n)/g, '&lt;br /&gt;');
       },
    
    },
   
    mounted(){
     

      this.getFlightByPending()
      this.getFlightByCam()
      this.getsalePrivilege()
      this.flightid = this.$route.params.flightid;
       if (this.$route.query.act){
         this.act = this.$route.query.act
      //  
      }
     

    },
    watch: {
      // active (val) {
      //   if (!val) return;

      //   setTimeout(() => (this.active = false), 10000);
      // }
    },
    beforeUpdate(){
      var countFlightCam = Object.keys(this.flightsByCam).length;
      if (countFlightCam > 0){
        setTimeout(() => (this.active = false), 2000);
        //this.active = false;
      }
   //   console.log(Object.keys(this.flightsByCam).length)

    //  if (this.userId){
     
       // console.log( this.isSalePrivilege)
      //}
     //console.log( storage.getItem('subscription') )
   //   console.log(this.$store.state.isSalePrivilege)
    
   
  },
  beforeMount(){
      
        this.id = this.$route.params.id
       // this.currency = localStorage.getItem('currency')
   },
   

   }
 </script>